import { Injectable, EventEmitter, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  ShowUtilityMenu(userBotRoles, superAdmin, chatbotAdmin, businessManager) {
    let isShowUtilityMenu = false;
    if (superAdmin) {
      return true;
    }
    
    if (userBotRoles != undefined && userBotRoles != null) {
      let userData = JSON.parse(userBotRoles);
      userData.forEach((item) => {
        if (item.botMasterConfigurations != null) {
          item.botMasterConfigurations.forEach((config) => {
            if (config.feature == 'ProactiveNotification' && config.enabled == true) {
              isShowUtilityMenu = true;
              return false;
            }
            else if (config.feature == 'FileUpload' && config.enabled == true) {
              isShowUtilityMenu = true;
              return false;
            }
            else if (config.feature == 'Broadcast' && config.enabled == true) {
              isShowUtilityMenu = true;
              return false;
            }
          });

          if (isShowUtilityMenu) {
            return false;
          }
        }
      });
      return isShowUtilityMenu && (chatbotAdmin || businessManager);
    }
    return isShowUtilityMenu;
  }

  ShowUtilityMenuItem(userBotRoles,featureName) {
    let isShowMenuItem = false;
    if (userBotRoles != undefined && userBotRoles != null) {
      let userData = JSON.parse(userBotRoles);
      userData.forEach((item) => {
        if (item.botMasterConfigurations != null) {

          item.botMasterConfigurations.forEach((config) => {
            if (config.feature == featureName && config.enabled == true) {
              isShowMenuItem = true;
              return false;
            }
          });

          if (isShowMenuItem) {
            return false;
          }

        }
      });
    }
    return isShowMenuItem;
  }

  GetFeaturewiseBotList(userBotRoles,featureName) {
    let botConfigIds = [];
    if (userBotRoles != undefined && userBotRoles != null) {
      let userData = JSON.parse(userBotRoles);      
      userData.forEach((item) => {
        if (item.botMasterConfigurations != null) {
          item.botMasterConfigurations.forEach((config) => {            
            if (config.feature == featureName && config.enabled == true) {
              botConfigIds.push(config.botConfigId)
            }
          });
        }
      });
    }
    let uniqueBotIds = [];
    for (let i of botConfigIds) {
      if (uniqueBotIds.indexOf(i) === -1) {
        uniqueBotIds.push(i);
      }
    }
    return uniqueBotIds;
  }

  
}
